module.exports = __webpack_public_path__ + "img/momchil-ganchev.573035bd.jpg";